import { render, staticRenderFns } from "./BadgeView.vue?vue&type=template&id=4ba87382"
import script from "./BadgeView.vue?vue&type=script&lang=ts"
export * from "./BadgeView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports